import { BoxMenuThemeSizeConfig } from './types';

const small: BoxMenuThemeSizeConfig = {
  BoxMenu: {},
};

export default small;
